import { inject, Injectable, signal } from '@angular/core';
import { Customer } from 'src/app/customer/customer.model';
import { EnterpriseSubscription } from "../enterprise-subscription/enterprise-subscription.model";
import { SessionStorageService } from './session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class ToolbarService {
    private sessionStorageService = inject(SessionStorageService);

    // Signals
    public isLoggedIn = signal<boolean>(!!this.sessionStorageService.getAccessToken());
    public customer = signal<Customer | null>(this.sessionStorageService.getCustomer() || null);
    public enterpriseFeatures = signal<EnterpriseSubscription[] | null>(null);

    updateLoggedInStatus(status: boolean) {
        this.isLoggedIn.set(status);
    }

    updateCustomer(customer: Customer | null) {
        this.customer.set(customer);
    }

    updateEnterpriseFeatures(features: EnterpriseSubscription[] | null) {
        this.enterpriseFeatures.set(features);
    }
}
